import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import { Box, Flex } from '@frontend/components';

export const InteractiveBox = ({ onClick, ...props }) => {
  return (
    <Box
      cursor="pointer"
      bg="page.surface"
      _hover={{
        background: 'interaction.surfaceHover',
      }}
      _active={{
        background: 'interaction.surfaceActive',
      }}
      onClick={onClick}
      {...props}
    >
      {props.children}
    </Box>
  );
};

export const InteractiveFlex = forwardRef(({ onClick, ...props }, ref) => {
  return (
    <Flex
      cursor="pointer"
      bg="page.surface"
      _hover={{
        background: 'interaction.surfaceHover',
      }}
      _active={{
        background: 'interaction.surfaceActive',
      }}
      onClick={onClick}
      ref={ref}
      {...props}
    >
      {props.children}
    </Flex>
  );
});

InteractiveFlex.displayName = 'InteractiveFlex';

export const InteractiveBoxAsLink = ({ to, onClick, ...props }) => {
  return (
    <Box
      cursor="pointer"
      as={Link}
      bg="page.surface"
      _hover={{
        background: 'interaction.surfaceHover',
      }}
      _active={{
        background: 'interaction.surfaceActive',
      }}
      to={to}
      onClick={onClick}
      {...props}
    >
      {props.children}
    </Box>
  );
};

export const InteractiveFlexAsLink = ({ to, onClick, ...props }) => {
  return (
    <Flex
      cursor="pointer"
      as={Link}
      _hover={{
        background: 'interaction.surfaceHover',
      }}
      _active={{
        background: 'interaction.surfaceActive',
      }}
      to={to}
      onClick={onClick}
      borderRadius="inherit"
      {...props}
    >
      {props.children}
    </Flex>
  );
};
